import { asyncComponentFactory } from '@utils';

const AppComponents = {
  // UI Components ------------------------------------------------------------
  Slider: asyncComponentFactory('ui/Slider'),
  Marquee: asyncComponentFactory('ui/Marquee'),
  QuantityInput: asyncComponentFactory('ui/QuantityInput'),
  MiniCart: asyncComponentFactory('ui/MiniCart'),
  Dialog: asyncComponentFactory('ui/Dialog'),
  QuickSearch: asyncComponentFactory('ui/QuickSearch'),
  JumpTo: asyncComponentFactory('ui/JumpTo'),
  //FacetFilters: asyncComponentFactory('ui/FacetFilters'),
  Accordion: asyncComponentFactory('ui/Accordion'),
  MediaPlayer: asyncComponentFactory('ui/MediaPlayer'),
  NewsletterForm: asyncComponentFactory('ui/NewsletterForm'),
  ShareButton: asyncComponentFactory('ui/ShareButton'),
  // MEDIA Components ------------------------------------------------------------
  // ResponsiveVideo: asyncComponentFactory('media/ResponsiveVideo'),
  // NAV Components ------------------------------------------------------------
  DesktopNav: asyncComponentFactory('nav/DesktopNav'),
  MobileNav: asyncComponentFactory('nav/MobileNav'),
  LazyLoader: asyncComponentFactory('nav/LazyLoader'),
  // PRODUCT Components ------------------------------------------------------------
  ProductForm: asyncComponentFactory('product/ProductForm'),
  ProductGallery: asyncComponentFactory('product/ProductGallery'),
  VariantPicker: asyncComponentFactory('product/VariantPicker'),
  ProductRecommendations: asyncComponentFactory('product/ProductRecommendations'),
  //SellingPlans: asyncComponentFactory('product/SellingPlans'),

  // CONTENT Components ------------------------------------------------------------
  Storyline: asyncComponentFactory('content/Storyline'),
};

export default AppComponents;
